<template>
  <SignInForm/>
</template>

<script>
// @ is an alias to /src
import SignInForm from "@/components/form/SignInForm.vue";

export default {
  name: "home",
  components: {
    SignInForm
  }
};
</script>
